import { ITaggingFlowOption } from 'interfaces/tagging/ITaggingFlowOption';
import { PitchTypes } from '@trackman/baseball-shared-components';
import { Hotkeys } from 'constants/Hotkeys';

export const PitchOptions: ITaggingFlowOption[] = [
  {
    displayName: 'Fastball',
    value: PitchTypes.FastBall,
    hotkeyCode: Hotkeys.PitchType.FastBall.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.FastBall.hotkeyDisplay,
  },
  {
    displayName: 'Four-seam Fastball',
    value: PitchTypes.FourSeamFastBall,
    hotkeyCode: Hotkeys.PitchType.FourSeamFastBall.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.FourSeamFastBall.hotkeyDisplay,
  },
  {
    displayName: 'Two-seam Fastball',
    value: PitchTypes.TwoSeamFastBall,
    hotkeyCode: Hotkeys.PitchType.TwoSeamFastBall.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.TwoSeamFastBall.hotkeyDisplay,
  },
  {
    displayName: 'One-seam Fastball',
    value: PitchTypes.OneSeamFastBall,
    hotkeyCode: Hotkeys.PitchType.OneSeamFastBall.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.OneSeamFastBall.hotkeyDisplay,
  },
  {
    displayName: 'Sinker',
    value: PitchTypes.Sinker,
    hotkeyCode: Hotkeys.PitchType.Sinker.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Sinker.hotkeyDisplay,
  },
  {
    displayName: 'Slider',
    value: PitchTypes.Slider,
    hotkeyCode: Hotkeys.PitchType.Slider.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Slider.hotkeyDisplay,
  },
  {
    displayName: 'Splitter',
    value: PitchTypes.Splitter,
    hotkeyCode: Hotkeys.PitchType.Splitter.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Splitter.hotkeyDisplay,
  },
  {
    displayName: 'Cutter',
    value: PitchTypes.Cutter,
    hotkeyCode: Hotkeys.PitchType.Cutter.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Cutter.hotkeyDisplay,
  },
  {
    displayName: 'Curveball',
    value: PitchTypes.Curveball,
    hotkeyCode: Hotkeys.PitchType.Curveball.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Curveball.hotkeyDisplay,
  },
  {
    displayName: 'ChangeUp',
    value: PitchTypes.ChangeUp,
    hotkeyCode: Hotkeys.PitchType.ChangeUp.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.ChangeUp.hotkeyDisplay,
  },
  {
    displayName: 'Knuckleball',
    value: PitchTypes.Knuckleball,
    hotkeyCode: Hotkeys.PitchType.Knuckleball.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Knuckleball.hotkeyDisplay,
  },
  {
    displayName: 'Sweeper',
    value: PitchTypes.Sweeper,
    hotkeyCode: Hotkeys.PitchType.Sweeper.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Sweeper.hotkeyDisplay,
  },
  {
    displayName: 'Other',
    value: PitchTypes.Other,
    hotkeyCode: Hotkeys.PitchType.Other.hotkeyCode,
    hotkeyDisplay: Hotkeys.PitchType.Other.hotkeyDisplay,
  },
];
